import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';
import ProductCard from '../components/ProductCard';

export default function Shop({ gender: propGender }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const page = parseInt(searchParams.get('page') || '1');
  const category = searchParams.get('category') || '';
  const gender = propGender || searchParams.get('gender') || '';
  const ordering = searchParams.get('ordering') || '';

  useEffect(() => {
    api.get('catalog/categories/').then(res => {
      const data = res.data.results || res.data;
      // Flatten parent + children for dropdown
      const flat = [];
      data.forEach(c => {
        flat.push(c);
        (c.children || []).forEach(ch => flat.push({ ...ch, name: `  ${ch.name}` }));
      });
      setCategories(flat);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = { page };
    if (category) params.category__slug = category;
    if (gender) params.gender = gender;
    if (ordering) params.ordering = ordering;
    api.get('catalog/products/', { params })
      .then(res => {
        const data = res.data;
        setProducts(data.results || data);
        if (data.count != null) setTotalPages(Math.ceil(data.count / 20));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page, category, gender, ordering]);

  const updateFilter = (key, value) => {
    const params = Object.fromEntries(searchParams);
    if (value) params[key] = value; else delete params[key];
    if (key !== 'page') params.page = '1';
    setSearchParams(params);
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 20px', display: 'flex', gap: 32 }}>
      <aside style={{ minWidth: 200, flexShrink: 0 }}>
        <h3 style={{ fontSize: 14, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16 }}>Filters</h3>

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#666' }}>Category</label>
          <select value={category} onChange={e => updateFilter('category', e.target.value)}
            style={{ display: 'block', width: '100%', padding: '8px', marginTop: 6, border: '1px solid #ddd' }}>
            <option value="">All</option>
            {categories.map(c => <option key={c.id} value={c.slug}>{c.name}</option>)}
          </select>
        </div>

        {!propGender && (
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#666' }}>Gender</label>
            <select value={gender} onChange={e => updateFilter('gender', e.target.value)}
              style={{ display: 'block', width: '100%', padding: '8px', marginTop: 6, border: '1px solid #ddd' }}>
              <option value="">All</option>
              <option value="M">Men</option>
              <option value="W">Women</option>
              <option value="U">Unisex</option>
            </select>
          </div>
        )}

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#666' }}>Sort By</label>
          <select value={ordering} onChange={e => updateFilter('ordering', e.target.value)}
            style={{ display: 'block', width: '100%', padding: '8px', marginTop: 6, border: '1px solid #ddd' }}>
            <option value="">Default</option>
            <option value="base_price">Price: Low to High</option>
            <option value="-base_price">Price: High to Low</option>
            <option value="-created_at">Newest</option>
          </select>
        </div>
      </aside>

      <main style={{ flex: 1 }}>
        {loading ? (
          <p style={{ textAlign: 'center', color: '#999', padding: 40 }}>Loading...</p>
        ) : products.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#999', padding: 40 }}>No products found.</p>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 24 }}>
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 40 }}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button key={i + 1} onClick={() => updateFilter('page', String(i + 1))}
                    style={{ padding: '8px 14px', border: '1px solid #ddd', background: page === i + 1 ? '#1a1a1a' : '#fff', color: page === i + 1 ? '#fff' : '#333', cursor: 'pointer' }}>
                    {i + 1}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}
